import { render, staticRenderFns } from "./mySocial.vue?vue&type=template&id=4b549854&scoped=true&"
import script from "./mySocial.vue?vue&type=script&lang=js&"
export * from "./mySocial.vue?vue&type=script&lang=js&"
import style0 from "./mySocial.vue?vue&type=style&index=0&id=4b549854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b549854",
  null
  
)

export default component.exports